var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#205EAC",
    fillRule: "evenodd",
    d: "M7.999 2.667A5.333 5.333 0 0 0 2.667 8a.667.667 0 1 1-1.334 0A6.667 6.667 0 0 1 8 1.333h.002a7.167 7.167 0 0 1 4.955 2.014l.008.008.368.369V2a.667.667 0 1 1 1.334 0v3.333A.667.667 0 0 1 14 6h-3.333a.667.667 0 1 1 0-1.333h1.723l-.364-.365a5.833 5.833 0 0 0-4.027-1.635Zm3.772 9.104c1-1 1.562-2.357 1.562-3.771a.667.667 0 1 1 1.334 0A6.667 6.667 0 0 1 8 14.667h-.003a7.167 7.167 0 0 1-4.954-2.014l-.008-.008-.368-.369V14a.667.667 0 1 1-1.334 0v-3.333c0-.369.299-.667.667-.667h3.333a.667.667 0 0 1 0 1.333H3.61l.365.365A5.833 5.833 0 0 0 8 13.333c1.414 0 2.77-.562 3.77-1.562Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.995db0355ebad62aa386d271bb66158b.svg";
export { ForwardRef as ReactComponent };